const RV_REDIRECT_FEATURE = 'use-riktiga-vykort-for-web2print'

export default {
  namespaced: true,
  state: {
    instance: null
  },
  mutations: {
    SET_GROWTHBOOK_INSTANCE(state, instance) {
      state.instance = instance
    }
  },
  getters: {
    isRVRedirectEnabled: state => {
      if (!state.instance) {
        return false
      }

      return state.instance.getFeatureValue(RV_REDIRECT_FEATURE, false)
    }
  }
}
